export const sxButtonContainedLight: object = {
  color: 'primary.main',
  backgroundColor: 'primary.light',
  '&:hover': { backgroundColor: '#B4C0FF' }
};
